import AgentConfigurationScreen from '../../components/agents/AgentConfigurationScreen';
import {
  serviceGetAgentConfiguration,
  serviceUpsertAgentConfiguration,
  serviceGenerateAgentConfiguration,
  serviceAttachTwilioNumber,
  serviceDetachTwilioNumber,
  patchServiceAgentFacebookEnabled,
} from '../../lib/api';

export default function ServiceAgentConfigurationPage() {
  return (
    <AgentConfigurationScreen
      roleLabel="Service"
      backPath="/service/agents"
      getConfiguration={serviceGetAgentConfiguration}
      saveConfiguration={serviceUpsertAgentConfiguration}
      generateConfiguration={serviceGenerateAgentConfiguration}
      attachTwilioNumber={serviceAttachTwilioNumber}
      detachTwilioNumber={serviceDetachTwilioNumber}
      patchFacebookEnabled={patchServiceAgentFacebookEnabled}
    />
  );
}
